import { userProfileStore } from 'modules/profileSettings/stores';

export const clearUserProfile = () => {
  userProfileStore.clearData();
};
